/**
 * Created by MinhQuan on 4/25/2016.
 */
angular.module('taric.duty.calculate.adco', ['taric.model.cd', 'common.filter.description']).controller('CalculateDutyAdcoCtrl', function (CalculateDutyModel, CONSTANTS, CommonHelper, $state, $stateParams) {
    var calculateDutyAdcoCtrl = this;
    calculateDutyAdcoCtrl.init = function () {
        calculateDutyAdcoCtrl.dateFormat = CONSTANTS.dateFormat;
        calculateDutyAdcoCtrl.calculationInput = CalculateDutyModel.getCalculationInput();
        calculateDutyAdcoCtrl.additionalCodes = CalculateDutyModel.getAdditionalCodes();
        calculateDutyAdcoCtrl.installationCountry = CONSTANTS.installationCountry;
        calculateDutyAdcoCtrl.isOpen = false;
        calculateDutyAdcoCtrl.categorizeAdditionalCodes();
        calculateDutyAdcoCtrl.updateSelectedAdditionalCodesFromParams();
        if (CalculateDutyModel.meursingAdditionalCode) {
            // Returned additional code from "search meursing additional code"
            calculateDutyAdcoCtrl.calculationInput.meursing = CalculateDutyModel.meursingAdditionalCode;
            CalculateDutyModel.meursingAdditionalCode = null;
        }
    };

    calculateDutyAdcoCtrl.updateSelectedAdditionalCodesFromParams = function () {
        if ($stateParams.ads && $stateParams.ads.length > 0){
            var pAds = [];
            if ($stateParams.ads.constructor === Array) {
                pAds = $stateParams.ads;
            } else {
                pAds.push($stateParams.ads);
            }

            // Loop through AdditionalCodes from parameters to select default value in each groups: eu, national, export refund, optional
            for (let adsCount = 0; adsCount < pAds.length; adsCount++) {
                var selectedAdditionalCode = false;

                // Update selected eu, national, or export refund AdditionalCode
                for (let groupCount = 0; groupCount < calculateDutyAdcoCtrl.additionalCodes.adcoGroups.length; groupCount++) {
                    if (!selectedAdditionalCode) {
                        for (let count = 0; count < calculateDutyAdcoCtrl.additionalCodes.adcoGroups[groupCount].items.length; count++) {
                            if (pAds[adsCount] === calculateDutyAdcoCtrl.additionalCodes.adcoGroups[groupCount].items[count].typeAndId) {
                                if (calculateDutyAdcoCtrl.additionalCodes.adcoGroups[groupCount].items[0].applicationCode === '0' ||
                                        calculateDutyAdcoCtrl.additionalCodes.adcoGroups[groupCount].items[0].applicationCode === '4'){
                                    // Update selected export refund AdditionalCode
                                    calculateDutyAdcoCtrl.calculationInput.exportRefundAdco = pAds[adsCount];
                                } else {
                                    // Update selected eu or national AdditionalCode
                                    calculateDutyAdcoCtrl.additionalCodes.adcoGroups[groupCount].selectedAdco = pAds[adsCount];
                                }

                                selectedAdditionalCode = true;
                                break;
                            }
                        }
                    } else {
                        break;
                    }
                }

                // Update selected optional AdditionalCode
                if (!selectedAdditionalCode) {
                    for (let opCount = 0; opCount < calculateDutyAdcoCtrl.optionalAdditionalCodes.length; opCount++) {
                        if (pAds[adsCount] === calculateDutyAdcoCtrl.optionalAdditionalCodes[opCount].typeAndId) {
                            calculateDutyAdcoCtrl.calculationInput.optionalAdco = pAds[adsCount];
                            selectedAdditionalCode = true;
                            break;
                        }
                    }
                }

                // Update meursing AdditionalCode from search criteria of 'Measures for nomenclature' use case.
                if (!selectedAdditionalCode) {
                    calculateDutyAdcoCtrl.calculationInput.meursing = pAds[adsCount];
                    calculateDutyAdcoCtrl.additionalCodes.meursingApplicable = true;
                }
            }
        }
    };

    calculateDutyAdcoCtrl.lookupMeursing = function() {
        let country = calculateDutyAdcoCtrl.calculationInput.country;
        if (CommonHelper.removeSpaceCharacters(calculateDutyAdcoCtrl.calculationInput.countryOfPreferentialOrigin) !== "" && 
            calculateDutyAdcoCtrl.calculationInput.preferenceCode &&
            (calculateDutyAdcoCtrl.calculationInput.preferenceCode.startsWith('2') || calculateDutyAdcoCtrl.calculationInput.preferenceCode.startsWith('3'))) {
            country = calculateDutyAdcoCtrl.calculationInput.countryOfPreferentialOrigin;
        }
        $state.go('taric.duty.meursing', {
            frm: 'taric.duty.calculate',
            sd: CommonHelper.getBookmarkDateString(calculateDutyAdcoCtrl.calculationInput.simulationDate),
            co: country,
            cu: calculateDutyAdcoCtrl.calculationInput.dutyCurrency
        });
    };

    calculateDutyAdcoCtrl.next = function () {
        var valid = calculateDutyAdcoCtrl.validateForm();
        if (valid) {
            calculateDutyAdcoCtrl.updateCalculationInput();
            calculateDutyAdcoCtrl.navigatingToNextTab = true;
            CalculateDutyModel.goToNextTab('additionalCodes').then(function(){
                calculateDutyAdcoCtrl.navigatingToNextTab = false;
            }, function (error) {
                calculateDutyAdcoCtrl.updateError(error);
                calculateDutyAdcoCtrl.navigatingToNextTab = false;

            });
        }
    };

    calculateDutyAdcoCtrl.updateCalculationInput = function(){
        calculateDutyAdcoCtrl.calculationInput.additionalCodes = [];
        calculateDutyAdcoCtrl.additionalCodes.adcoGroups.forEach(function(group){
            if(group.selectedAdco && group.selectedAdco !== ""){
                calculateDutyAdcoCtrl.calculationInput.additionalCodes.push(group.selectedAdco);
            }
        });
        if (CONSTANTS.showOptionalAdditionalCodes && calculateDutyAdcoCtrl.calculationInput.optionalAdco && calculateDutyAdcoCtrl.calculationInput.optionalAdco !== "") {
            calculateDutyAdcoCtrl.calculationInput.additionalCodes.push(calculateDutyAdcoCtrl.calculationInput.optionalAdco);
        }
        if (calculateDutyAdcoCtrl.additionalCodes.meursingApplicable){
            var meursingCode = CommonHelper.removeSpaceCharacters(calculateDutyAdcoCtrl.calculationInput.meursing);
            if (meursingCode !== ""){
                calculateDutyAdcoCtrl.calculationInput.additionalCodes.push(meursingCode);
            }
        }
        if (calculateDutyAdcoCtrl.calculationInput.exportRefundAdco && calculateDutyAdcoCtrl.calculationInput.exportRefundAdco !== ""){
            calculateDutyAdcoCtrl.calculationInput.additionalCodes.push(calculateDutyAdcoCtrl.calculationInput.exportRefundAdco);
        }

    };

    calculateDutyAdcoCtrl.categorizeAdditionalCodes = function () {
        calculateDutyAdcoCtrl.euAdditionalCodes = [];
        calculateDutyAdcoCtrl.exportRefundAdditionalCodes = [];
        calculateDutyAdcoCtrl.nationalAdditionalCodes = [];
        calculateDutyAdcoCtrl.optionalAdditionalCodes = [];
        calculateDutyAdcoCtrl.additionalCodes.adcoGroups.forEach(function(group){
            if (group.items.length > 0){
                if (group.items[0].national){
                    calculateDutyAdcoCtrl.nationalAdditionalCodes.push(group);
                } else {

                    //If it is an export refund group, add an 'None' option at the end of the group for the user to select.
                    if (group.items[0].applicationCode === '0' || group.items[0].applicationCode === '4'){
                        var noneOption = {
                            typeAndId: "",
                            descriptionKey: "i8n.qry.cd.additionalCodesTab.none"
                        };
                        group.items.forEach(function(item){
                            calculateDutyAdcoCtrl.exportRefundAdditionalCodes.push(item);
                        });
                        calculateDutyAdcoCtrl.exportRefundAdditionalCodes.push(noneOption);
                    } else {

                        //Put the group under EU group
                        calculateDutyAdcoCtrl.euAdditionalCodes.push(group);
                    }
                }
            }
        });
        if (CONSTANTS.showOptionalAdditionalCodes) {
            if (!CalculateDutyModel.getOptionalAdditionalCodes()) {
                CalculateDutyModel.loadOptionalAdditionalCodes().then(function (result) {
                    calculateDutyAdcoCtrl.optionalAdditionalCodes = result.items;
                }, function (error) {
                    calculateDutyAdcoCtrl.updateError(error);
                });
            } else {
                calculateDutyAdcoCtrl.optionalAdditionalCodes = CalculateDutyModel.getOptionalAdditionalCodes().items;
            }
        }
    };

    calculateDutyAdcoCtrl.updateError = function(error){
        if (!error){
            calculateDutyAdcoCtrl.errorCode = null;
            calculateDutyAdcoCtrl.errorParams = null;
            calculateDutyAdcoCtrl.errorType = null;
        } else {
            calculateDutyAdcoCtrl.errorCode = error.data.code;
            calculateDutyAdcoCtrl.errorParams = error.data.params;
            calculateDutyAdcoCtrl.errorType = error.data.errorType;
        }
    };
    calculateDutyAdcoCtrl.validateForm = function () {
        calculateDutyAdcoCtrl.updateError(null);
        return calculateDutyAdcoCtrl.validateMeursingAdditionalCode() &&
             calculateDutyAdcoCtrl.validateEUAdditionalCodes() &&
             calculateDutyAdcoCtrl.validateNationalAdditionalCodes();
    };

    calculateDutyAdcoCtrl.validateMeursingAdditionalCode = function () {
        if (!calculateDutyAdcoCtrl.additionalCodes.meursingApplicable || CommonHelper.removeSpaceCharacters(calculateDutyAdcoCtrl.calculationInput.meursing) !== ""){
            return true;
        } else {
            calculateDutyAdcoCtrl.errorCode = "i8n.qry.cd.additionalCodesTab.meursing.missing";
            return false;
        }
    };

    calculateDutyAdcoCtrl.validateEUAdditionalCodes = function () {
        for (let i = 0; i < calculateDutyAdcoCtrl.euAdditionalCodes.length; i++){
            var group = calculateDutyAdcoCtrl.euAdditionalCodes[i];
            if(!group.selectedAdco || group.selectedAdco === ""){
                calculateDutyAdcoCtrl.errorCode = "i8n.qry.cd.additionalCodesTab.eu-additionalcodes.missing";
                return false;
            }
        }
        return true;
    };

    calculateDutyAdcoCtrl.validateNationalAdditionalCodes = function () {
        for (let i = 0; i < calculateDutyAdcoCtrl.nationalAdditionalCodes.length; i++){
            var group = calculateDutyAdcoCtrl.nationalAdditionalCodes[i];
            if(!group.selectedAdco || group.selectedAdco === ""){
                calculateDutyAdcoCtrl.errorCode = "i8n.qry.cd.additionalCodesTab.national-additionalcodes.missing";
                return false;
            }
        }
        return true;
    };

});





// WEBPACK FOOTER //
// ./app/taric/duties/calculate/additional-codes/additional-codes.js